import { ReactNode } from 'react';

import { Features } from '@lessonPlanner/constants';
import { REGEX } from '@lessonPlanner/regex';

import { routeToFeatureMap } from '../constants/featureMap';
import Activities from '../pages/activities';
import Analogy from '../pages/analogy';
import CatchUpFridays from '../pages/catch-up-fridays';
import CrossSubjectExtension from '../pages/cross-subject-extension';
import DLL from '../pages/dll';
import Elif from '../pages/elif';
import Energizer from '../pages/energizer';
import GenericUnpacking from '../pages/generic-unpacking';
import IplanObjective from '../pages/iplan-objective';
import LessonPlan from '../pages/lesson-plan';
import Multigrade from '../pages/multigrade';
import Objective from '../pages/objective';
import PhotoBooth from '../pages/photo-booth';
import PptMaker from '../pages/ppt-maker';
import Quizmaker from '../pages/quizmaker';
import SummativeTest from '../pages/summative-test';
import TopicExplorer from '../pages/topic-explorer';
import UnitPlan from '../pages/unit-plan';

const featureToComponentMap: Partial<Record<Features, () => ReactNode>> = {
  [Features.LESSON_PLAN]: () => <LessonPlan />,
  [Features.OBJECTIVES]: () => <Objective />,
  [Features.ACTIVITIES]: () => <Activities />,
  [Features.ANALOGY]: () => <Analogy />,
  [Features.CATCH_UP_FRIDAYS]: () => <CatchUpFridays />,
  [Features.SUBJECT_EXTENSIONS]: () => <CrossSubjectExtension />,
  [Features.DLL]: () => <DLL />,
  [Features.ELIF]: () => <Elif />,
  [Features.ENERGIZER]: () => <Energizer />,
  [Features.GENERIC_UNPACKING]: () => <GenericUnpacking />,
  [Features.IPLAN_OBJECTIVES]: () => <IplanObjective />,
  [Features.MULTIGRADE_LESSON_PLAN]: () => <Multigrade />,
  [Features.PHOTO_BOOTH]: () => <PhotoBooth />,
  [Features.PPT_MAKER]: () => <PptMaker />,
  [Features.QUIZMAKER]: () => <Quizmaker />,
  [Features.SUMMATIVE_TEST]: () => <SummativeTest />,
  [Features.TOPIC_EXPLORER]: () => <TopicExplorer />,
  [Features.UNIT_PLAN]: () => <UnitPlan />,
};

export const createPageComponent = (path: string): ReactNode => {
  const cleanPath = path.replace(REGEX.CLEAN_PATH, '');
  const feature = routeToFeatureMap[cleanPath];

  if (feature) {
    const componentFactory = featureToComponentMap[feature];
    return componentFactory ? (
      componentFactory()
    ) : (
      <div>Component not found</div>
    );
  }

  return <div>Unknown page: {path}</div>;
};
